import {Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, OnChanges, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";

@Component({
  selector: 'micro-transform-select',
  templateUrl: './transform-select.component.html'
})
export class TransformSelectComponent implements OnInit, OnChanges  {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Output()
  transformIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  transformId:any;

  @Input()
  placeholder:any = 'Transform';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  change(e) {
    this.transformIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
    }
  }

  reload() {
    let params:HttpParams = new HttpParams()
    ;
    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/transform/transforms`, {params:params})
      .subscribe(data => {
        this.options = data as any[]
        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.reload();
  }
}
